import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './roomsintro.scss';
import { ViewGallery } from './view-gallery/view-gallery';
import { RoomsInfo } from '../rooms-info';

export function RoomsIntro(){

    const [showLocation, setShowLocation] = useState(false);
    const [showGallery, setShowGallery] = useState(false);

    function handleClose(){
        setShowLocation(false);
    }

    function setLocation(){
        setShowLocation(true);
    }

    function showLocationModal(){
        if(showLocation){
            return (
                <LocationModal show={showLocation} handleClose={handleClose}></LocationModal>
            )
        }
    }

    function setViewGallery(){
        setShowGallery(true);
    }

    function hideViewGallery(){
        setShowGallery(false);
    }

    function displayGalleryModal(){
        const imagesList = RoomsInfo.map(info => info.carouselImages);
        const carouselList = [];
        imagesList.forEach(
            images => {
                carouselList.push(...images);
            }
        )
        console.log(carouselList);
        if(showGallery){
            return (
            <ViewGallery show={showGallery} imagesList={carouselList} handleClose={hideViewGallery}/>
        )
        }
    }

    return (
        <div className="rooms-intro">
            <div className='gallery'>
                <div className='gallery-image-1'>
                    <img src='gallery/exterior/exterior_5.jpg' alt='exterior' loading="eager" decoding="async"></img>
                </div>
                <div className='gallery-image-2'>
                    <div className='gallery-image-2_1'>
                        <img src='gallery/exterior/exterior_7.jpg' alt='exterior' loading="lazy" decoding="async"></img>
                    </div>
                    <div className='gallery-image-2_2'>
                        <img src='gallery/restaurant/restaurant_3.jpg' alt='restaurant' loading="lazy" decoding="async"></img>
                    </div>
                </div>
                <div className='view-gallery-btn'>
                    <button onClick={() => setViewGallery()}>
                        View Gallery
                    </button>
                </div>
            </div>
            <div className='intro flex-center'>
                <div className='hotel-info flex-center'>
                    <span className='font-2-2'>Hotel Janas</span>
                    <span>Iskon Road, Near Kapiltheertham, Tirupati</span>
                </div>
                <div className='contact-section hotel-info-divider'>
                    <a href='mailto:janashotels@outlook.com'><img src='email.png' alt='email' loading="lazy" decoding="async"></img></a>
                    <a href='https://api.whatsapp.com/send?phone=9490490077'><img src='whatsapp.png' alt='whatsapp' loading="lazy" decoding="async"></img></a>
                    <a onClick={setLocation}><img src='location.png' alt='location' loading="lazy" decoding="async"></img></a>
                    {
                        showLocationModal()
                    }
                </div>
                <div className='checkin-checkout'>
                    <span className='bold-font margin-03'>Check In:</span>
                    <span>1:00 PM</span>
                    <span className='divider'></span>
                    <span className='bold-font margin-03'>Check Out:</span>
                    <span>11:00 AM</span>
                </div>
            </div>
            {
                displayGalleryModal()
            }
        </div>
    )
}
export function LocationModal({show, handleClose}){

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Hotel Janas Location</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <iframe title='Hotel Janas Location'
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3877.1684419474814!2d79.41592777573027!3d13.647515599698256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4d4b00201bab8f%3A0x5a6c275273e066a8!2sJANAS%20HOTEL!5e0!3m2!1sen!2sin!4v1738928528582!5m2!1sen!2sin" 
                style={{'border': '0', 'width': '100%', 'height': '50vh'}} 
                allowfullscreen="" 
                loading="lazy" 
                referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </Modal.Body>
        </Modal>
    )
}